import { locales } from '../../../data';

const localesFunc = (state = locales) => state;

export default localesFunc;